import React from "react";

const NotAuthorizedPage = () => (
  <>
    <h1>Unauthorized</h1>
    <p>You do not have permission to view this page.</p>
  </>
);

export default NotAuthorizedPage;
